import { render, staticRenderFns } from "./GroupWords.vue?vue&type=template&id=643419da&scoped=true&"
import script from "./GroupWords.vue?vue&type=script&lang=js&"
export * from "./GroupWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643419da",
  null
  
)

export default component.exports